import { Component, input, output } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';

export interface ImagePreview {
  file: File | null;
  url: string;
  name: string;
  size: string;
  isExisting: boolean;
  order: number;
  storagePath?: string;
  altText?: string;
  caption?: string;
  uploadedAt?: Timestamp;
}

@Component({
  selector: 'app-news-image',
  imports: [],
  templateUrl: './news-image.component.html',
  styleUrl: './news-image.component.css'
})
export class NewsImageComponent {
  readonly preview = input.required<ImagePreview>();
  readonly remove = output<void>();

  protected onRemove(): void {
    this.remove.emit();
  }
}
